import { Currency } from '../model/currency';

export const currencies = Object.values(Currency)
    .filter((c) => c !== Currency.CURRENCY_UNSPECIFIED)
    .map((value) => ({
        value,
        label: value.replace('CURRENCY_', '').replaceAll('_', ''),
    }));
